import { UPDATE_SESSION_MUTATION } from "@graphql"
import { useMutation } from "@apollo/client"

const useUpdateSession = () => {
  const [updateSession, {data, loading, error}] = useMutation(UPDATE_SESSION_MUTATION)

  return {
    updateSession,
    data,
    loading,
    error,
  }
}

export default useUpdateSession